export const updateLastDocumentPathElementWithIdSuffix = (
  documentPath: string[],
  id: string,
): string[] => [
  ...documentPath.slice(0, -1),
  `${documentPath[documentPath.length - 1]}.${id}`,
];
